import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoaderService, Loader, LoaderSession } from './loader.service';
import { SessionStorageService } from 'ngx-webstorage';
import { ApplicationService } from '../../application/application.service';
import { TokenService } from '../../token/token.service';
import * as Sentry from '@sentry/browser';

declare var Materialize: any;
declare var $: any;

@Component({
  selector: 'zest-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {

  public loader: Loader;
  public showTickingTimer = false;
  public tickingTimerText: string;

  private concurrency = [];
  private loaderTimer: NodeJS.Timer = null;
  private tickingTimerInterval: NodeJS.Timer = null;

  private loaderMessagesFor3To10Sec = [
    'Our customer’s rate us 4.7 out of 5',
    'EMI is the smart way to pay',
    'Never pay in full, always Zest it!',
    'Zest = EMI',
  ];
  private loaderMessagesFor10To15Sec = [
    'ZestMoney EMI works across 1000 + merchant partners',
    'ZestMoney is making EMI available to everyone for everything',
    'Experience the best products & services by paying for them using ZestMoney EMI',
  ];
  private loaderMessagesFor15To30Sec = [
    'Auto repayments helps us collect your EMI on time, always.Ensuring your credit score is safe with us.',
    'We care deeply about your credit score and help you improve it by collecting EMI automatically on the due date.',
    'Remember timely EMI payments help increase your credit score, 100 % of our customers who make timely payments have observed this increase.',
  ];
  private loaderMessagesFor30To45Sec = [
    'We know it’s taking more time than usual, we appreciate your patience. Thank you so much.',
    'We apologize for the delay in this process.You’ll soon be able to move forward to the next step.',
  ];
  private loaderMessagesFor45To120Sec = [
    'It should not take this long, we are experiencing a high load at this point of time.'
  ];
  private loaderMessagesFor120AndBeyond = [
    'Something went wrong. Please try again after sometime.'
  ];

  constructor(private loaderService: LoaderService, private tokenService: TokenService, private applicationService: ApplicationService, private sessionStorage: SessionStorageService) {
    this.loaderService.ShowLoaderSource.subscribe(
      result => {
        if (!this.getLoaderStatus()) {
          this.setLoaderStatus(result.show, 0);
          if (result.show) {
            this.showLoader(0, result.timeInSeconds, result.text);
          }
        }
        if (result.timeInSeconds && result.timeInSeconds > 0) {
          this.setLoaderStatus(result.show, 0);
          if (this.loaderTimer) {
            clearInterval(this.loaderTimer);
            this.loaderTimer = null;
          }
          if (this.tickingTimerInterval) {
            clearInterval(this.tickingTimerInterval);
            this.tickingTimerInterval = null;
          }
        }
        if ((result.show && this.getLoaderStatus().show) || (result.show && !this.getLoaderStatus().show) || (!result.show && this.getLoaderStatus().show)) {
          if (!(result.show && this.getLoaderStatus().show)) {
            this.setLoaderStatus(result.show, 0);
            if (result.show) {
              this.showLoader(0, result.timeInSeconds, result.text);
            }
          }
          if (result.show && this.getLoaderStatus().show && !this.checkForLoaderNode()) {
            this.setLoaderStatus(result.show, 0);
            if (result.show) {
              this.showLoader(0, result.timeInSeconds, result.text);
            }
          }
          if (result.show && this.getLoaderStatus().show && this.getLoaderStatus().counter < 1 && !this.loaderTimer) {
            if (!result.timeInSeconds || result.timeInSeconds === 0) {
              this.loaderTimer = setInterval(() => {
                if (this.getLoaderStatus() && this.getLoaderStatus().show) {
                  const counter = this.getLoaderStatus().counter + 1;
                  this.setLoaderStatus(true, counter);
                  this.showLoader(counter, result.timeInSeconds, result.text);
                } else {
                  this.hideLoader();
                }
              }, 1000);
            } else {
              this.setLoaderStatus(result.show, 0);
              clearInterval(this.loaderTimer);
              this.loaderTimer = null;
              this.showLoader(0, result.timeInSeconds, result.text);
            }
          }
          if (!this.getLoaderStatus().show) {
            this.hideLoader();
          }
        }
      }
    );
  }
  ngOnInit() {
    this.loader = new Loader(false, '', 0);
    const interval = setInterval(fn => {
      const application = this.applicationService.getApplication();
      if (application !== null && this.applicationService.getConcurrency() && this.loader) {
        this.concurrency = this.applicationService.getConcurrency();
        if (!this.loader.show) {
          this.showToast();
          clearInterval(interval);
        }
      }
    }, 1000);
  }
  ngOnDestroy() {
    this.loader = new Loader(false, '', 0);
    $('body').css('overflow', 'unset');
    $('html').css('overflow', 'unset');
    clearInterval(this.loaderTimer);
    this.loaderTimer = null;
    clearInterval(this.tickingTimerInterval);
    this.tickingTimerInterval = null;
  }
  showToast() {
    if (this.concurrency['status'] && this.concurrency['count'] === false) {
      Materialize.toast('You have an existing loan with ZestMoney, to view details use menu on the right.', 5000, 'rounded', () => { this.tokenService.removeAllToasts(); });
      this.concurrency['count'] = true;
      this.applicationService.saveConcurrency(this.concurrency);
    }
  }
  setLoaderStatus(showStatus: boolean, counter: number) {
    this.sessionStorage.store('zest-loader', new LoaderSession(showStatus, counter));
  }
  getLoaderStatus() {
    return this.sessionStorage.retrieve('zest-loader') ? this.sessionStorage.retrieve('zest-loader') as LoaderSession : null;
  }
  hideLoader() {
    // DO NOT REMOVE THIS SETTIMEOUT OR CHANGE THIS TIMER INTERVAL - DON'T KNOW WHAT MIGHT BREAK
    setTimeout(() => {
      this.loader = new Loader(false, '', 0);
      $('body').css('overflow', 'unset');
      $('html').css('overflow', 'unset');
    }, 500);
    clearInterval(this.loaderTimer);
    this.loaderTimer = null;
    clearInterval(this.tickingTimerInterval);
    this.tickingTimerInterval = null;
    this.tickingTimerText = null;
    this.showTickingTimer = null;
  }
  showLoader(counter: number, timeInSeconds: number, text: string) {
    const message = (timeInSeconds === 0) ? this.getMessage(counter) : text;
    this.loader = new Loader(true, message, timeInSeconds);
    if (timeInSeconds && timeInSeconds > 0) {
      this.getTickingTimer(timeInSeconds);
    }
    $('body').css('overflow', 'hidden');
    $('html').css('overflow', 'hidden');
  }
  getTickingTimer(timeInSeconds: number) {
    this.showTickingTimer = true;
    this.tickingTimerInterval = setInterval(() => {
      const minutes = Math.floor(timeInSeconds / 60);
      const seconds = Math.floor(timeInSeconds % 60);
      if (minutes === 0 && seconds === 0) {
        clearInterval(this.tickingTimerInterval);
        this.showTickingTimer = false;
        this.tickingTimerText = null;
        this.loader.text = '<span>This is taking longer than usual. Please refresh the page to try again, or call <b>080-61950299</b> to check the status of this application.</span>';
      } else {
        this.tickingTimerText = minutes + ' m : ' + ((seconds > 9) ? seconds : ('0' + seconds)) + ' s';
        timeInSeconds--;
      }
    }, 1000);
  }
  getMessage(counter: number) {
    let message = (this.loader && this.loader.text) ? this.loader.text : '';
    let random = 0;
    if (counter < 3) {
      message = '';
    } else if (counter === 3) {
      random = this.getRandomNumberWithinRange(0, this.loaderMessagesFor3To10Sec.length);
      message = this.loaderMessagesFor3To10Sec[random];
    } else if (counter === 10) {
      random = this.getRandomNumberWithinRange(0, this.loaderMessagesFor10To15Sec.length);
      message = this.loaderMessagesFor10To15Sec[random];
    } else if (counter === 15) {
      random = this.getRandomNumberWithinRange(0, this.loaderMessagesFor15To30Sec.length);
      message = this.loaderMessagesFor15To30Sec[random];
    } else if (counter === 30) {
      random = this.getRandomNumberWithinRange(0, this.loaderMessagesFor30To45Sec.length);
      message = this.loaderMessagesFor30To45Sec[random];
    } else if (counter === 45) {
      random = this.getRandomNumberWithinRange(0, this.loaderMessagesFor45To120Sec.length);
      message = this.loaderMessagesFor45To120Sec[random];
    } else if (counter === 120) {
      random = this.getRandomNumberWithinRange(0, this.loaderMessagesFor120AndBeyond.length);
      Sentry.captureMessage('Infinite Loader');
      message = this.loaderMessagesFor120AndBeyond[random];
    }
    return message;
  }
  getRandomNumberWithinRange(min, max) {
    // min inclusive, max exclusive
    return Math.floor(Math.random() * (max - min) + min);
  }
  checkForLoaderNode() {
    return document.getElementsByClassName('loader-block').length === 1 ? true : false;
  }
}
